import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { StrategyFlowAction } from './strategy-selection-drawer/strategy-selection-drawer.component';

@Injectable({
  providedIn: 'root',
})
export class StrategySelectionService {
  private readonly flowActionSubject = new Subject<StrategyFlowAction>();
  private readonly resetSelectionSubject = new Subject<void>();

  readonly flowAction$ = this.flowActionSubject.asObservable();
  readonly resetSelection$ = this.resetSelectionSubject.asObservable();

  emitFlowAction(action: StrategyFlowAction): void {
    this.flowActionSubject.next(action);
  }

  emitResetSelection(): void {
    this.resetSelectionSubject.next();
  }
}
